import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store, select } from '@ngrx/store';
import {
  NotificationService,
  ROUTE_ANIMATIONS_ELEMENTS
} from '../../../core/core.module';
import { EntityTecnicoResponsableAcreditacionDialogFormContainerComponent } from '../../roles/entity-tecnico-responsable/components/entity-tecnico-responsable-acreditacion-dialog-form-container/entity-tecnico-responsable-acreditacion-dialog-form-container.component';
import { selectAuthTecnicoResponsable } from '../../roles/entity-tecnico-responsable/entity-tecnico-responsable.selectors';
import { State } from '../../vista-usuario/vista-usuario.state';
import { TecnicoResponsable } from '../../roles/entity-tecnico-responsable/entity-tecnico-responsable.model';
import { INavigationRoutes } from '../interfaces/navegation.interface';
import { Subscription, combineLatest } from 'rxjs';
import { selectAuthPersona } from '../../persona/entity-personas/entity-personas.selectors';
import { selectAuthTecnicos } from '../../roles/entity-tecnicos/entity-tecnicos.selectors';
import { Tecnico } from '@rpe/registro-personas-empresas-lib/src/lib/tecnico/tecnicos.model';
import { Router } from '@angular/router';
import { selectAuthUser } from '../../../core/auth/auth.selectors';
import { Persona } from '@rpe/registro-personas-empresas-lib';
import { EntidadesProductiva } from '../../empresas/entity-entidad-productiva/entity-entidades-productiva.model';
import {
  selectAllRolesByCurrentEmpresa,
  selectRolesPropios
} from '../../roles/entity-roles/entity-roles.selectors';
import { Rol } from '../../roles/entity-roles/roles.model';
import { EntityAcreditacionEmpresa } from '../../empresas/acreditacion-empresa/entity-acreditacion-empresa.model';
import { selectAcreditacionEmpresaByCurrentEmpresa } from '../../empresas/acreditacion-empresa/entity-acreditacion-empresa.selectors';
import { selectCurrentEmpresa } from '../../empresas/entity-mis-empresas/entity-current-empresa.selectors';
import {
  selectAllEntidadesProductiva,
  selectEntidadesProductivaFromAuthPersona
} from '../../empresas/entity-entidad-productiva/entity-entidades-productiva.selectors';

@Component({
  selector: 'rpe-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LandingComponent implements OnInit, OnDestroy {
  authTecnicoResponsableSubscription: Subscription;

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;

  subscription: Subscription[] = [];

  releaseButler: string = 'assets/release-butler.png';

  esTecnicoResponsable: boolean = false;

  auxTecnicoResponsable: TecnicoResponsable;
  currentEntidadProductiva: EntidadesProductiva;
  currentEntidadedesProductivas: EntidadesProductiva[];
  currentRolesOfEntidadProductiva: Rol[] = [];
  authPersonaRoles: Rol[] = [];
  acreditacionesEmpresa: EntityAcreditacionEmpresa[] = [];

  persona: Persona = {} as Persona;
  allTecnicos: Tecnico[];
  userToken: string = '';

  navigationRoutes: INavigationRoutes[] = [
    {
      module: 'Empresa',
      isActive: true,
      childrenRoutes: [
        {
          isActive: true,
          name: 'Inscripción en el Registro General de Semilleristas',
          route: '/empresas/registro-empresa'
        },
        {
          isActive: true,
          name: 'Gestión de empresa',
          route: '/empresas/mi-empresa'
        },
        {
          isActive: false,
          name: 'Registro de actividades',
          route: '/actividades/seleccion'
        }
      ]
    },
    {
      module: 'Persona',
      isActive: true,
      childrenRoutes: [
        {
          isActive: true,
          name: 'Habilitación de Técnico/a Responsable',
          action: () => {
            this.router.navigate(['/roles/vista-tecnico-responsable']);
          },
          disabled: () => {
            return this.disabledTR();
          },
          tooltip: () => {
            return this.disabledTR()
              ? 'La solicitud de inscripción de Técnico Responsable ya fue enviada'
              : '';
          }
        },
        {
          isActive: false,
          name: 'Solicitud de muestreador',
          route: '/roles/vista-muestreador'
        },
        // {
        //   isActive: true,
        //   name: 'Habilitación de muestreador/a de lotes de semilla',
        //   action: () => this.abrirDialogoArchivos(),
        //   disabled: () => {
        //     return this.disabledTRA();
        //   },
        //   tooltip: () => {
        //     return this.disabledTRA()
        //       ? 'La solicitud de inscripción para la acreditación de certificación de semillas ya fue solicitada.'
        //       : '';
        //   }
        // },
        {
          isActive: true,
          name: 'Gestión de vínculo persona - empresa',
          route: '/roles/vinculos-laborales'
        }
      ]
    },
    {
      module: 'Trámites',
      isActive: true,
      childrenRoutes: [
        {
          isActive: true,
          name: 'Gestión de trámites',
          route: '/tramite/vista-tramites'
        },
        {
          isActive: false,
          name: 'Acreditación de Empresa para Certificación',
          action: () => {
            this.router.navigate(['/tramite/acreditacion-empresa']);
          },
          disabled: () => {
            return this.disableAcreditacionEmpresa();
          },
          tooltip: () => {
            return this.disableAcreditacionEmpresa()
              ? 'Para solicitar la acreditación de la empresa, la misma debe estar dada de ALTA en el RGS, debe contar con un técnico responsable habilitado, quien lo solicita debe ser responsable de la empresa y no debe existir una solicitud pendiente previa.'
              : '';
          }
        }
      ]
    }
  ];

  constructor(
    private dialog: MatDialog,
    private store: Store<State>,
    private router: Router,
    private readonly notificationService: NotificationService
  ) { }

  ngOnInit() {
    // se busca el tecnico responsable asociado
    this.authTecnicoResponsableSubscription = this.store
      .pipe(select(selectAuthTecnicoResponsable))
      .subscribe(
        (tecnicosResponsable) =>
          (this.auxTecnicoResponsable = tecnicosResponsable)
      );

    // Esto es que no exista una entidad de
    // tecnicoResponsable con un tecnico con una persona_id igual
    // a la logueada

    const personaSubscription = combineLatest([
      this.store.pipe(select(selectAuthPersona)),
      this.store.pipe(select(selectAuthTecnicos)),
      this.store.pipe(select(selectAuthUser)),
      this.store.pipe(select(selectRolesPropios))
    ]).subscribe(([persona, allTecnicos, userToken, rolesPropios]) => {
      this.persona = persona as unknown as Persona;
      this.allTecnicos = allTecnicos;
      this.userToken = userToken.token;
      this.authPersonaRoles = rolesPropios;
    });

    const currentEmpresaSubscription = combineLatest([
      this.store.pipe(select(selectAllRolesByCurrentEmpresa)),
      this.store.pipe(select(selectCurrentEmpresa)),
      this.store.pipe(select(selectAllEntidadesProductiva)),
      this.store.pipe(select(selectEntidadesProductivaFromAuthPersona))
    ]).subscribe(
      ([roles, currentEmpresa, entidadesProductiva, empresasPersona]) => {
        this.currentEntidadProductiva = entidadesProductiva.find(
          (entidad) => entidad.id === currentEmpresa?.id
        );
        this.currentEntidadedesProductivas = empresasPersona;
        this.currentRolesOfEntidadProductiva = roles;
      }
    );

    const acreditacionesEmpresaSubscription = this.store
      .pipe(select(selectAcreditacionEmpresaByCurrentEmpresa))
      .subscribe((acreditaciones) => {
        this.acreditacionesEmpresa = acreditaciones;
      });

    this.subscription.push(
      personaSubscription,
      currentEmpresaSubscription,
      acreditacionesEmpresaSubscription
    );
  }

  navigateTo(route: string): void {
    this.router.navigate([route]);
  }

  disabledTR(): boolean {
    return this.auxTecnicoResponsable ? true : false;
  }

  disabledTRA(): boolean {
    return this.auxTecnicoResponsable
      ? this.auxTecnicoResponsable.tecnico.acreditado == 2
      : false;
  }

  ngOnDestroy(): void {
    this.subscription.forEach((s) => s.unsubscribe());
    this.authTecnicoResponsableSubscription.unsubscribe();
  }

  abrirDialogoArchivos(): void {
    // si no se hallo el tecnico responsable se muestra un error y se sale con un return
    if (this.auxTecnicoResponsable == null) {
      this.notificationService.error(
        'Debe registrarse como Técnico Responsable para poder solicitar la acreditación'
      );
      return;
    }

    // se hallo el tecnico responsable entonces se abre un dialogo
    const dialogRef = this.dialog.open(
      EntityTecnicoResponsableAcreditacionDialogFormContainerComponent,
      {
        width: '550px',
        data: this.auxTecnicoResponsable
      }
    );
  }

  disableAcreditacionEmpresa(): boolean {
    const empresa = this.currentEntidadProductiva;

    if (!empresa) {
      return false;
    }

    if (empresa.estado != 3) {
      return true;
    }

    if (!this.findTrHabilitado()) {
      return true;
    }

    if (!this.findResponsableEmpresa()) {
      return true;
    }

    if (this.findAcreditacionSolicitada()) {
      return true;
    }

    return false;
  }

  findTrHabilitado(): boolean {
    const trHabilitado = this.currentRolesOfEntidadProductiva.find((rol) => {
      return (
        rol.tipo_rol_id === 6 &&
        !rol.fecha_baja &&
        rol.vinculo_aprobado_entidad_productiva &&
        rol.vinculo_aprobado_rol
      );
    });

    return trHabilitado ? true : false;
  }

  findResponsableEmpresa(): boolean {
    const responsableEmpresa = this.authPersonaRoles.find((rol) => {
      return (
        rol.tipo_rol_id <= 6 &&
        !rol.fecha_baja &&
        rol.vinculo_aprobado_entidad_productiva &&
        rol.vinculo_aprobado_rol
      );
    });

    return responsableEmpresa ? true : false;
  }

  findAcreditacionSolicitada(): boolean {
    const acreditacionSolicitada = this.acreditacionesEmpresa.find(
      (acreditacion) => {
        return acreditacion.estado_acreditacion_id === 2;
      }
    );

    return acreditacionSolicitada ? true : false;
  }
}
